import { Component, EventEmitter, Input, OnDestroy, OnInit } from '@angular/core';
import { AirSearchService } from 'src/app/services/air/air-search.service';
import { SeaSearchService } from 'src/app/services/sea/sea-search.service';
import { Subject } from 'rxjs';

export const onSelectHistory = new Subject<any>();

export function slowScrollToBottom(duration = 3000) {
  const start = window.scrollY || window.pageYOffset;
  const end = document.body.scrollHeight;
  const distance = end - start;
  const startTime = performance.now();


  const step = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1); // 0 ile 1 arası
    const ease = progress * (2 - progress); // ease-out

    window.scrollTo(0, start + distance * ease);

    if (progress < 1) {
      requestAnimationFrame(step);
    }
  };

  requestAnimationFrame(step);
}

@Component({
  selector: 'app-search-history-component',
  templateUrl: './search-history.component.html',
  styleUrls: ['./search-history.component.scss']
})


export class SearchHistoryComponent implements OnInit, OnDestroy {

  flightCards = [];
  currentPage = 0;
  itemsPerPage = 6
  historyTabOpen = false;
  loading: boolean = true;

  @Input("operation") operation: string = "sea";


  constructor(private airService: AirSearchService, private seaService: SeaSearchService) {  }

  ngOnDestroy(): void {
  }

  selectLog(log: any) {
       onSelectHistory.next(JSON.stringify(log))
  }

  async ngOnInit() {

    this.historyTabOpen = true;
    this.loading = true;
    try {
      if (this.operation == 'sea') {
        this.flightCards = await this.seaService.searchHistory().toPromise();
      } 
      if(this.operation == 'air') {
        this.flightCards = await this.airService.searchHistory().toPromise();
      }
      this.loading = false;
    } catch {
      this.loading = false;
    }
  

  }

    onCarouselPageChange(event: any): void {
    this.currentPage = event.page;

    const startIndex = this.currentPage * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;

    const visibleLogs = this.flightCards.slice(startIndex, endIndex);

    visibleLogs.forEach(log => {
      log.step = 0; // veya stepper başlangıcı neyse
    });
  }


toggleHistoryTab() {
  this.historyTabOpen = !this.historyTabOpen;
  setTimeout(() => this.smoothScrollTo(0, 800), 100);
}

smoothScrollTo(target: number, duration: number) {
  const start = window.scrollY || document.documentElement.scrollTop;
  const change = target - start;
  const startTime = performance.now();

  const animateScroll = (currentTime: number) => {
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1); // 0 → 1 arası
    const ease = 0.5 - Math.cos(progress * Math.PI) / 2; // easeInOut
    window.scrollTo(0, start + change * ease);

    if (progress < 1) {
      requestAnimationFrame(animateScroll);
    }
  };

  requestAnimationFrame(animateScroll);
}



}
